import isStringSet from '../is/isStringSet';
import repository from 'client/repository';

export const QRType = {
    Card: 'C',
    VisitorPass: 'V',
    Unknown: ''
}

export function processQRCode(qrCode) {

    let promise = new Promise((resolve, reject) => {

        let type = QRType.Unknown;
        let code = "";

        qrCode = qrCode.split('@').join('"').split('#').join('\\');

        if (isVirtualCard(qrCode)) {
            repository.virtualCards
                .lookupCardByVirtualQr(qrCode)
                .then(response => {
                    resolve({ qrCode: response.qrCode, qrType: QRType.Card });
                }).catch(err => {
                    resolve({ qrCode, qrType: QRType.Unknown });
                });

        } else if (qrCode.indexOf("/") >= 0) {
            const qrParts = qrCode.split("/");

            if (qrParts.length === 5) {
                type = qrParts[3];
                code = qrParts[4];
            } else {
                type = QRType.Unknown;
                code = qrCode;
            }

            resolve({ qrCode: code, qrType: type });

        } else {
            code = qrCode;

            resolve({ qrCode: code, qrType: type });
        }
    });

    return promise;
}

export function isVirtualCard(qrCode) {
    try {
        const js = JSON.parse(qrCode);
        return js.vr === "2.0" && isStringSet(js.si) && isStringSet(js.dt);

    } catch (error) {
        return false;
    }
}

export function extractCardNumber(qrCode) {
    const segments = qrCode.split("_");
    if (segments && segments.length === 3) {
        return segments[1];
    }

    return "";
}